import React, { useContext } from 'react';
import { Toaster } from 'react-hot-toast';
import classNames from 'classnames';

import Container from './Container';
import MobileNav from './MobileNav';
import SideNav from './SideNav';
import { UserContext } from '../../App';
import usePostHogIdentify from '../../hooks/usePostHogIdentify';

const primaryRoutes = [
  {
    icon: ['fas', 'house-blank'],
    name: 'Home',
    url: '/',
  },
];

export default function PortalLayout({ children }) {
  const user = useContext(UserContext);
  usePostHogIdentify(user?.user);

  return (
    <div
      className={classNames('h-screen font-avenir-book', {
        'md:grid md:grid-cols-13': user?.user,
      })}
      role={PortalLayout.role}
    >
      {user?.user && <SideNav primaryRoutes={primaryRoutes} />}
      <Container
        utilClasses={classNames(
          !user?.user
            ? 'w-full'
            : 'grid grid-rows-auto-1fr md:pt-10 md:container',
        )}
      >
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          toastOptions={{
            duration: 6000,
            style: {
              boxShadow: 'none',
              minWidth: '20%',
              background: 'none',
            },
          }}
        />
        {user?.user && <MobileNav primaryRoutes={primaryRoutes} />}
        <div>{children}</div>
      </Container>
    </div>
  );
}

PortalLayout.role = 'portal-layout-component';
